import { styled } from '@material-ui/core';

export const FullPageContainer = styled('div')({
    alignItems: 'center',
    display: 'flex',
    height: '100vh',
    justifyContent: 'center',
    textAlign: 'center',
    width: '100vw',
});
